module.exports = __webpack_public_path__ + "static/img/eyeglass.801691f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eyeglass.png
// module id = Tk0v
// module chunks = 21